<template>
  <nav class="user-menu">
    <v-btn href="https://app.motanamy.com" v-if="isDesktop" text>{{ $t('header.login') }}</v-btn>
    <v-spacer v-if="isDesktop" class="vertical-divider" />
    <setting-menu />
  </nav>
</template>

<style lang="scss" scoped>
@import "../header-style.scss";
</style>

<script>
import Settings from "./Settings";

export default {
  components: {
    "setting-menu": Settings
  },
  computed: {
    isDesktop() {
      const smUp = this.$store.state.breakpoints.smUp;
      return smUp.indexOf(this.$mq) > -1;
    }
  }
};
</script>
